// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Priorities_SalvarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/priorities/salvar
 *
 * Handles both create and update of priorities:
 * - Create: so_priority_name required
 * - Update: so_priority_id + so_priority_name required
 */
import { registerContract } from './validate'

export interface Priorities_SalvarInput {
so_priority_name: string
so_priority_id?: number
so_priority_color?: string
}

registerContract('Priorities_SalvarInput', {
  so_priority_name:  { type: 'string',  required: true },
  so_priority_id:    { type: 'number',  required: false },
  so_priority_color: { type: 'string',  required: false },
})
